import { styled } from 'styled-components';

export const SliderWrapper = styled.div`
  margin-top: ${({ theme }) => theme.sizing.tiny};
  height: 12px;

  div {
    transition-duration: 0s !important;
    animation-duration: 0s !important;
  }
`;
SliderWrapper.displayName = 'SliderWrapper';

export const SliderDisplay = styled.div`
  position: relative;
  width: 100%;
  padding-left: ${({ $padding }) => `${$padding}%` || '0'};
  padding-right: ${({ $padding }) => `${$padding}%` || '0'};
  color: ${({ theme }) => theme.colours.ink.primary.main};

  & > span {
    display: block;
    width: 50%;
    float: left;
    height: 1.2rem;
    text-align: center;
    font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
  }
  & > span:first-child {
    text-align: left;
    font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
    width: 25%;
  }
  & > span:last-child {
    text-align: right;
    font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
    width: 25%;
  }

  & > button {
    display: block;
    width: 50%;
    float: left;
    font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
  }

  & > span > button {
    display: block;
    width: 40%;
    float: left;
  }
  & > span > button:last-child {
    float: right;
  }
`;
SliderDisplay.displayName = 'SliderDisplay';
